export const NEWS_QUERY_KEYS = {
  published: 'one-news-published',
};

export const getQueryKey = (id) => [NEWS_QUERY_KEYS.published, `${id}`];
